// Creates a class which function is solely to scroll to the top of the
// React application. Source:https://reacttraining.com/react-router/web/guides/scroll-restoration
import React from 'react';

class ScrollToTopOnMount extends React.Component {

  componentDidMount() {
    // Because body has overflow: hidden, scrollTop is always 0 for it. We have where the react
    // node is rendered and then get its offset
    const node = document.getElementById('main-center');
    if ( node && node.firstChild && node.firstChild.firstChild ) node.firstChild.firstChild.scrollTop = 0;
  	else console.warn("Couldn't scroll to top!");
  }

  render() {
    return null;
  }
}

export default ScrollToTopOnMount;
